/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low-carb 40/20/40`)
};

const es_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajo en carbohidratos 40/20/40`)
};

const de_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohlenhydratarm 40/20/40`)
};

const nl_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koolhydraatarm 40/20/40`)
};

const fr_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauvre en glucides 40/20/40`)
};

const it_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low-carb 40/20/40`)
};

const pt_br2_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low-carb 40/20/40`)
};

const pt_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixa em hidratos 40/20/40`)
};

const ja_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低炭水化物 40/20/40`)
};

const zh_macro_lowcarb = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低碳型 40/20/40`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_lowcarb = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_lowcarb(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_lowcarb", locale)
	if (locale === "en") return en_macro_lowcarb(inputs)
	if (locale === "es") return es_macro_lowcarb(inputs)
	if (locale === "de") return de_macro_lowcarb(inputs)
	if (locale === "nl") return nl_macro_lowcarb(inputs)
	if (locale === "fr") return fr_macro_lowcarb(inputs)
	if (locale === "it") return it_macro_lowcarb(inputs)
	if (locale === "pt-BR") return pt_br2_macro_lowcarb(inputs)
	if (locale === "pt") return pt_macro_lowcarb(inputs)
	if (locale === "ja") return ja_macro_lowcarb(inputs)
	return zh_macro_lowcarb(inputs)
};